export default "__VITE_ASSET__rPhzhPq6__"